import React, { useEffect } from "react";
import styles from "./style/MyProfilePage.module.css";
import { Avatar } from "@components/common";
import clsx from "clsx";
import {
  Button,
  Col,
  Container,
  Nav,
  Row,
  Spinner,
  Tab,
} from "react-bootstrap";
import { CourseCard } from "@components/CourseCard";
import { InstructorCard } from "@components/InstructorCard";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  allSubscriptionAction,
  getMyCoursesAction,
  getMyPurchasesAction,
  getProfileAction,
  getTotalEnrollInstructorAction,
  getTotalReviewInstructorAction,
  getTotalReviewUserAction,
  myTotalEnrollmentAction,
} from "@redux/actions";
import { GroupSocialLink } from "@components/GroupSocialLink";
import { APP_TITLE_SUFFIX, INSTRUCTOR_ROLE, STUDENT_ROLE } from "@constants";
import { useLayoutEffect } from "react";
import { NoData } from "@components";

const MyProfilePage = () => {
  // state
  const location = useLocation();

  let defaultTab = "about";
  if (location.hash === "#subscriptions") {
    defaultTab = "subscriptions";
  }

  const { unsubscribe, allSubscription } = useSelector(
    (state) => state.subscription
  );
  const profile = useSelector((state) => state.user.profile.data);
  const { myCourses, myPurchases } = useSelector(
    (state) => state.instructorCourse
  );
  const { getTotalReviewInstructor, getTotalReviewUser } = useSelector(
    (state) => state.review
  );

  const { getTotalEnrollInstructor, myTotalEnrollment } = useSelector(
    (state) => state.enrollment
  );

  const { login } = useSelector((state) => state.auth);
  const { role } = login;

  // variables

  // logics before hooks

  // hooks
  const dispatch = useDispatch();

  // logics

  // UI partials
  let statisticData = [];
  if (role === INSTRUCTOR_ROLE) {
    statisticData = [
      {
        loading: getTotalEnrollInstructor.processing,
        name: "Enroll Student",
        data: getTotalEnrollInstructor.data ?? 0,
      },
      {
        loading: myCourses.processing,
        name: "Courses",
        data: myCourses.data?.length,
      },
      {
        loading: getTotalReviewInstructor.processing,
        name: "Reviews",
        data: getTotalReviewInstructor.data ?? 0,
      },
      {
        loading: allSubscription.processing,
        name: "Subscriptions",
        data: allSubscription.data?.length,
      },
    ];
  }
  if (role === STUDENT_ROLE) {
    statisticData = [
      {
        loading: myPurchases.processing,
        name: "Purchased",
        data: myPurchases.data?.length,
      },
      {
        loading: myTotalEnrollment.processing,
        name: "Enrolled",
        data: myTotalEnrollment.data ?? 0,
      },
      {
        loading: getTotalReviewUser.processing,
        name: "Reviews",
        data: getTotalReviewUser.data ?? 0,
      },
      {
        loading: allSubscription.processing,
        name: "Subscriptions",
        data: allSubscription.data?.length,
      },
    ];
  }
  const statistic = (
    <div
      className={clsx(
        styles.statistic,
        "d-flex mt-4 w-100 justify-content-between flex-wrap"
      )}
    >
      {statisticData.map((item, index) => {
        return (
          <div className="info text-center py-2 flex-1" key={index}>
            <h6>{item.name}</h6>
            {item.loading ? (
              <Spinner animation="border" size="sm" variant="light" />
            ) : (
              <span>{item.data}</span>
            )}
          </div>
        );
      })}
    </div>
  );

  const basicInfo = (
    <div className={clsx(styles.avatar, "d-flex align-items-center gap-3")}>
      <Avatar className="d-inline" src={profile?.avatarUrl} width={80} />
      <div className="name text-white">
        <h5>{profile?.fullName}</h5>
        <div>{profile?.headLine}</div>
      </div>
    </div>
  );

  const actionPart = (
    <div className="action">
      <Link
        to={
          role === INSTRUCTOR_ROLE
            ? "/instructor-dashboard"
            : "/student-dashboard"
        }
        className={"text-decoration-none text-white"}
      >
        <Button>Cursus Studio</Button>
      </Link>
    </div>
  );

  const tabs = (
    <Nav variant="pills" className="pt-4 container">
      <Nav.Item className={styles.navItem}>
        <Nav.Link eventKey="about">About</Nav.Link>
      </Nav.Item>
      {role === INSTRUCTOR_ROLE && (
        <Nav.Item className={styles.navItem}>
          <Nav.Link eventKey="courses">Courses</Nav.Link>
        </Nav.Item>
      )}
      <Nav.Item className={styles.navItem}>
        <Nav.Link eventKey="purchased">Purchased</Nav.Link>
      </Nav.Item>
      <Nav.Item className={styles.navItem}>
        <Nav.Link eventKey="subscriptions">Subscriptions</Nav.Link>
      </Nav.Item>
    </Nav>
  );

  const tabContent = (
    <Tab.Content>
      <Tab.Pane eventKey="about">
        <div className="container pt-4 px-0">
          <h4>About</h4>
          <p>{profile?.description}</p>
        </div>
      </Tab.Pane>
      {role === INSTRUCTOR_ROLE && (
        <Tab.Pane eventKey="courses">
          <div className="container pt-4 px-0">
            <h4>My Course</h4>
            <div className="row mt-4">
              {myCourses.data?.length ? (
                myCourses.data?.map((course, index) => {
                  return (
                    <div
                      key={index}
                      className="col-lg-3 col-sm-6 col-xs-12 mb-4"
                    >
                      <CourseCard data={course} type="manage" />
                    </div>
                  );
                })
              ) : (
                <Col>
                  <NoData title="No Course" />
                </Col>
              )}
            </div>
          </div>
        </Tab.Pane>
      )}
      <Tab.Pane eventKey="purchased">
        <div className="container mt-4 px-0">
          <h4>Purchased Course</h4>
          <div className="row mt-4">
            {myPurchases.data?.length ? (
              myPurchases.data?.map((item) => {
                return (
                  <div key={item.id} className="col-9 mb-3">
                    <CourseCard data={item} variant={"horizontal"} />
                  </div>
                );
              })
            ) : (
              <Col>
                <NoData title="No Purchased Course" />
              </Col>
            )}
          </div>
        </div>
      </Tab.Pane>
      <Tab.Pane eventKey="subscriptions">
        <div className="container pt-4 px-0">
          <h4>Subscription</h4>
          <div className="row">
            {allSubscription.data?.length ? (
              allSubscription.data?.map((item, index) => {
                return (
                  <div key={index} className="col-lg-3 col-sm-6 col-xs-12 mb-4">
                    <InstructorCard data={item} variant={"subscribed"} />
                  </div>
                );
              })
            ) : (
              <Col>
                <NoData title="No Subscription" />
              </Col>
            )}
          </div>
        </div>
      </Tab.Pane>
    </Tab.Content>
  );

  // effects
  useEffect(() => {
    dispatch(getProfileAction());
    dispatch(getMyCoursesAction({ status: 1, IsActive: true }));
    dispatch(getMyPurchasesAction());

    if (role === INSTRUCTOR_ROLE) {
      dispatch(getMyCoursesAction({ status: 1, IsActive: true }));
      dispatch(getTotalReviewInstructorAction());
      dispatch(getTotalEnrollInstructorAction());
    }

    if (role === STUDENT_ROLE) {
      dispatch(myTotalEnrollmentAction());
      dispatch(getTotalReviewUserAction());
    }
  }, []);

  useEffect(() => {
    dispatch(allSubscriptionAction());
  }, [unsubscribe]);

  useLayoutEffect(() => {
    document.title = `Profile | ${APP_TITLE_SUFFIX}`;
    return () => {
      document.title = APP_TITLE_SUFFIX;
    };
  }, []);

  // render
  return (
    <div className="">
      <div className={clsx(styles.header)}>
        <Container className="py-5">
          <Row className="row justify-content-between">
            <Col lg={6} xs={12} className="leftSide mb-3">
              {basicInfo}
              {statistic}
            </Col>
            <Col
              className={clsx(styles.rightSide, "d-flex flex-column")}
              lg={4}
              xs={12}
            >
              <Link
                to={"/setting"}
                className={"text-decoration-none text-white"}
              >
                <i className="bi bi-gear"></i> Setting
              </Link>
              <GroupSocialLink
                className={""}
                facebookLink={profile?.facebookLink}
                linkedinLink={profile?.linkedlnLink}
                youtubeLink={profile?.youtubeLink}
              />
              {actionPart}
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid>
        <Tab.Container defaultActiveKey={defaultTab}>
          <Row className={clsx(styles.tabContainer)}>
            <Col sm={12} className="bg-white">
              {tabs}
            </Col>
            <Col sm={12}>{tabContent}</Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

/* required: display name */
MyProfilePage.displayName = "MyProfilePage";

/* required: props types */
MyProfilePage.propTypes = {};

/* required: default props */
MyProfilePage.defaultProps = {};

export { MyProfilePage };
